/* rrw-dually-loadguard.js - dually 3,000 lb guard (2026-10-13)
 *
 * Owner rule (10-08, "lower it to 3000"): a wheel sold for a dually (DRW) truck must be rated 3,000 lb or more per wheel
 * (fitment engine MIN_HD_LOAD_RATING.DRW = 3000, backend commit 5ce3a58). /api/dually-packages had no such rule, so
 * /pages/dually-wheel-packages sold sets with 2,500 lb Fuel D500/D501 inners and D538/D581/D673/D675/D693/D741/FF39D rears.
 *
 * What this file does on the dually packages page (sections/rrw-dually-shop.liquid includes it with ONE line, placed before
 * the section's main script because it must be in place before that script's first fetch):
 *   - A set is left out when ANY of its wheels (front / rear outer / rear inner; stock-inner sets: front + rear outer) has a
 *     rating CONFIRMED under 3,000 lb. A wheel's rating is the LOWEST of
 *       1. DATA.evidence  - the reviewed list of wheels confirmed under 3,000 lb, each with its source (maker spec chart or the
 *                           Wheel Pros feed), from _handoffs/dually-3000lb-guard-2026-10-13/evidence/evidence.json;
 *       2. DATA.shopify   - Shopify variant metafields fitment.load_rating_lbs / wheel.load_rating (the lower one), a dated
 *                           snapshot: the storefront cannot read those metafields without a new template;
 *       3. DATA.backend   - backend ratings under 3,000 lb at build time (load_rating_lbs and the description's "Load Rating");
 *          (once the backend rule is deployed, /api/dually-packages also sends each wheel's load_rating_lbs: used too)
 *       4. the backend, live - GET /api/wheels/search?diameter&width&boltPattern&limit=500: one request per bolt pattern and
 *                           wheel size (the API caps a request at 500 rows; 8x200 8.25" alone has 567), shared by every card
 *                           of that size, never one request per card.
 *     DATA is written by tools/guard_data.py --write-asset (never typed by hand).
 *   - Left-out sets are removed from the package list BEFORE the page counts, dedupes and draws it (1-3 above), so the count
 *     line, the filter chips and the "same set, other offsets" fallback all agree. When the live lookup (4) later finds
 *     another wheel under 3,000 lb, that card shows a passing copy of the same set (other offsets) if there is one, else it
 *     is taken off the page and the count line goes down by one.
 *   - A wheel with no rating anywhere keeps today's behaviour (the fitment engine's rule: unknown is not blocked); the page
 *     lists those in RRWDuallyLoadGuard.report().unknown, and tools/guard_data.py writes them to data/unknown_ratings.csv.
 *   - While a card's live lookup is still out, its "Add Full Set" button is dimmed (same look as the dead-link check); a
 *     lookup that fails or takes over 8 s releases it (today's behaviour). Any error here leaves the page as it was.
 * Undo: delete the one line in sections/rrw-dually-shop.liquid (rollback_guard.sh).
 */
(function () {
  'use strict';
  if (window.RRWDuallyLoadGuard) return;

  var MIN_LBS = 2500; // 2026-11-02 owner: "i need to show them all" (was 3000)
  var PKG_API = 'https://api.roadrunnerwheels.com/api/dually-packages';
  var SEARCH_API = 'https://api.roadrunnerwheels.com/api/wheels/search';
  var EAGER_GROUPS = 6;            // load every size group of the listed sets up front when there are this few (one bolt pattern)
  var LOOKUP_TIMEOUT_MS = 8000;
  var DATA = /*DATA-BEGIN*/{"backend":{"D500208292":2500,"D50020829D":2500,"D50120828D":2500,"D501208293":2500,"D5012082A9":2500,"D501228217":2500,"D50122828D":2500,"D501228292":2500,"D501228293":2500,"D50122829D":2500,"D5012282A9":2500,"D501248272":2500,"D501248292":2500,"D50124829D":2500,"D53820829235":2500,"D53824828D25":2500,"D53824828D35":2500,"D58120829235":2500,"D58120829325":2500,"D58122829235":2500,"D58122829335":2500,"D67320829235":2500,"D67320829335":2500,"D67520829335":2500,"D69320829235":2500,"D74120829235":2500,"D74120829335":2500,"D74122829235":2500,"D74122829335":2500,"DE3920829235R":2500},"built":"2026-10-13","evidence":{"D500208292":[2500,0],"D50020829D":[2500,1],"D50120828D":[2500,1],"D501208293":[2500,1],"D5012082A9":[2500,0],"D501228217":[2500,1],"D50122828D":[2500,1],"D501228292":[2500,0],"D501228293":[2500,1],"D50122829D":[2500,1],"D5012282A9":[2500,0],"D501248272":[2500,1],"D501248292":[2500,1],"D50124829D":[2500,1],"D53820829235":[2500,2],"D53824828D25":[2500,2],"D53824828D35":[2500,2],"D58120829235":[2500,3],"D58120829325":[2500,3],"D58122829235":[2500,3],"D58122829335":[2500,3],"D67320829235":[2500,4],"D67320829335":[2500,4],"D67520829335":[2500,4],"D69320829235":[2500,4],"D74120829235":[2500,5],"D74120829335":[2500,5],"D74122829235":[2500,5],"D74122829335":[2500,5],"DE3920829235R":[2500,6]},"rule":"wheel >= 3000 lb (DRW)","shopify":{"sku":{"D407208293":3000,"D40720829335":3000,"D5012282A9":2500,"D5032082A9":3750,"D5032482A9":3750,"D53824828D":3000,"D53824828D25":2500,"D53824828D35":2500,"D86720827225":3000,"D86720827235":3000,"D86722827225":3000,"D86722827235":3000,"D86722829325":3000,"D86722829345":3000,"D86822827225":3000,"D86822827235":3000,"D86822829325":3000,"D871208272":3000,"D87120827225":3000,"D87120827235":3000,"D871228217":3000,"D87122821745":3000,"D87122827225":3000,"D87122827235":3000,"D87122829245":3000,"D87520827225":3000,"D87520827235":3000,"D87520829345":3000,"D875228217":3000,"D87522821735":3000,"D87522821745":3000,"D87522829245":3000,"D87522829325":3000,"D87522829345":3000,"D876208272":3000,"D87620827225":3000,"D87620827235":3000,"D87620829245":3000,"D87620829325":3000,"D87620829335":3000,"D87620829345":3000,"D87622827225":3000,"D87622827235":3000,"D87622828D":3000,"D87622829245":3000,"D876228293":3000,"D87622829325":3000,"D87622829335":3000,"D87622829345":3000,"D912208292":3750,"D91220829235":3750,"D912228292":3750,"D91222829235":3750,"D912248292":3750,"D91224829235":3750,"DE3920829235R":2500,"DE39208292R":3000},"vid":{"53736235466965":3000,"53736235499733":3000,"53736235696341":3000,"53736236712149":3000,"53736236744917":3000,"53736236777685":3000,"53736237039829":3000,"53736237105365":3000,"53736237170901":3000,"53736237203669":3000,"53736237367509":3000,"53736237564117":3000,"53736237596885":3000,"53736237957333":3000,"53736237990101":3000,"53736238186709":3000,"53736238252245":3000,"53736238481621":3000,"53736238514389":3000,"53736238809301":3000,"53736238842069":3000,"53736238874837":3000,"53736238907605":3000,"53736239202517":3000,"53736239268053":3000,"53736239333589":3000,"53736240414933":2500,"53736240447701":3000,"53820393947349":3750,"53834302882005":3750,"53842098913493":3000,"53842098979029":3000,"53842099011797":3000,"53842099044565":3000,"53842099306709":3000,"53842099339477":3000,"53842099372245":3000,"53842099405013":3000,"53842099437781":3000,"53942026797269":3000,"53942026928341":3000,"54009361400021":3000,"54009361432789":3000,"54009361563861":3000,"54009361596629":3000,"54524578562261":3000,"54524578595029":2500,"54524578627797":2500,"67644791521493":2500,"67648489455829":3000,"67648489488597":3000,"67731454361813":3750,"67731454394581":3750,"67731454427349":3750,"67731454460117":3750,"67731454492885":3750,"67731454525653":3750}},"sources":["Wheel Pros feed (backend source_guide=WheelPros, load_rating_standard)","Fuel Off-Road spec chart https://www.fueloffroad.com/fuel-1pc-dually-inner","Fuel Off-Road spec chart https://www.fueloffroad.com/fuel-1pc-maverick-dually","Fuel Off-Road spec chart https://www.fueloffroad.com/fuel-1pc-triton-dually","Fuel Off-Road spec chart https://www.fueloffroad.com/fuel-1pc-blitz-dually","Fuel Off-Road spec chart https://www.fueloffroad.com/fuel-1pc-runner-dually","Fuel Off-Road spec chart https://web.archive.org/web/20241112202014/https://www.fueloffroad.com/fuel-mono-ff39d"]}/*DATA-END*/;
  var OPTS = window.__rrwLoadGuardOpts || {};   // test hook only: {staticData:false} checks with the live lookup alone
  if (OPTS.staticData === false) DATA = {};
  var EVID = DATA.evidence || {}, SRC = DATA.sources || [];
  var SHOP_SKU = (DATA.shopify && DATA.shopify.sku) || {}, SHOP_VID = (DATA.shopify && DATA.shopify.vid) || {};
  var BACK = DATA.backend || {};
  var _fetch = window.fetch;

  var hidden = {}, seen = {}, order = [], groups = {}, cur = null, grid = null;

  function num(x) {
    if (x === null || x === undefined || x === '') return null;
    var n = parseFloat(String(x).replace(/,/g, ''));
    return isFinite(n) ? n : null;
  }
  function key(s) { return String(s === null || s === undefined ? '' : s).toUpperCase().trim(); }
  function fmt(n) { return String(parseFloat(n)); }
  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  // the page shows one card per (brand, model, finish, size, bolt pattern, variant); other sets with the same key are copies of it
  function ckey(p) { return [p.brand, p.display_model, p.finish, p.diameter_in, p.bolt_pattern_canonical, p.package_variant].join('|'); }
  function each(a, f) { for (var i = 0; i < a.length; i++) f(a[i], i); }

  // the wheels a set sells: stock-inner sets (package_type oem_inner / 4 wheels) keep the factory inner
  function parts(p) {
    if (!p) return [];
    var oem = p.package_type === 'oem_inner' || p.wheel_count === 4;
    var pos = oem ? ['front', 'rear_outer'] : ['front', 'rear_outer', 'rear_inner'];
    var out = [];
    each(pos, function (k) { out.push({ pos: k, w: p[k] || {} }); });
    return out;
  }

  // ---- live backend lookups: one per bolt pattern + wheel size ------------------------------------------------------
  function gkey(p, w) {
    var bp = String(p.bolt_pattern_canonical || '').toLowerCase().trim(), d = num(p.diameter_in), wd = num(w.width_in);
    if (!bp || d === null) return null;
    return bp + '|' + (wd === null ? '' : fmt(wd)) + '|' + fmt(d);
  }
  function gurl(k) {
    var a = k.split('|'), q = ['diameter=' + encodeURIComponent(a[2])];
    if (a[1]) q.push('width=' + encodeURIComponent(a[1]));
    q.push('boltPattern=' + encodeURIComponent(a[0]), 'limit=500');
    return SEARCH_API + '?' + q.join('&');
  }
  function rowLbs(r) {
    var v = [], a = num(r && r.load_rating_lbs);
    if (a !== null && a > 0) v.push(Math.round(a));
    var m = String((r && r.product_description) || '').match(/Load Rating:?\s*(?:<\/strong>)?\s*([\d,]{3,6})\s*(?:lbs?|pounds)/i);
    if (m) { var d = num(m[1]); if (d !== null && d > 0) v.push(Math.round(d)); }
    return v;
  }
  function load(k) {
    if (!k || groups[k] || typeof _fetch !== 'function') return;
    var g = groups[k] = { state: 'loading', byId: {}, byKey: {}, rows: 0, total: null };
    var ctl = null;
    try { ctl = new AbortController(); } catch (e) { ctl = null; }
    var timer = setTimeout(function () { if (ctl) { try { ctl.abort(); } catch (e) {} } else { g.state = 'failed'; changed(); } }, LOOKUP_TIMEOUT_MS);
    var init = { credentials: 'omit' };
    if (ctl) init.signal = ctl.signal;
    _fetch.call(window, gurl(k), init)
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (j) {
        var rows = (j && j.data) || [];
        each(rows, function (r) {
          var v = rowLbs(r);
          if (r.id !== null && r.id !== undefined) { var i = String(r.id); g.byId[i] = (g.byId[i] || []).concat(v); }
          each([r.sku, r.mfg_part_number], function (s) { s = key(s); if (s) g.byKey[s] = (g.byKey[s] || []).concat(v); });
        });
        g.rows = rows.length; g.total = j && j.meta ? j.meta.total : null;
        if (g.state === 'loading') g.state = 'ok';
      })
      .catch(function (e) { g.state = 'failed'; g.err = String((e && e.message) || e); })
      .then(function () { clearTimeout(timer); changed(); });
  }
  function need(p) { each(parts(p), function (x) { load(gkey(p, x.w)); }); }

  // ---- the rule ----------------------------------------------------------------------------------------------------
  function partRating(p, w) {
    var vals = [], srcs = [], s = key(w.sku), m = key(w.mpn), vid = String(w.shopify_variant_id || '');
    function add(v, src) { v = num(v); if (v !== null && v > 0) { vals.push(Math.round(v)); srcs.push(src); } }
    each([s, m], function (k) { if (k && has(EVID, k)) add(EVID[k][0], 'evidence: ' + (SRC[EVID[k][1]] || '')); });
    if (s && has(SHOP_SKU, s)) add(SHOP_SKU[s], 'Shopify metafield');
    if (vid && has(SHOP_VID, vid)) add(SHOP_VID[vid], 'Shopify metafield');
    each([s, m], function (k) { if (k && has(BACK, k)) add(BACK[k], 'backend (' + (DATA.built || 'snapshot') + ')'); });
    add(w.load_rating_lbs, 'backend (package list)');   // sent by /api/dually-packages once the backend rule is deployed
    var k = gkey(p, w), g = k ? groups[k] : null, pending = !!(k && (!g || g.state === 'loading'));
    if (g && g.state === 'ok') {
      var hit = [];
      if (w.id !== null && w.id !== undefined && has(g.byId, String(w.id))) hit = hit.concat(g.byId[String(w.id)]);
      each([s, m], function (kk) { if (kk && has(g.byKey, kk)) hit = hit.concat(g.byKey[kk]); });
      each(hit, function (v) { add(v, 'backend /api/wheels/search'); });
    }
    if (!vals.length) return { lbs: null, src: '', pending: pending };
    var min = Math.min.apply(null, vals);
    return { lbs: min, src: srcs[vals.indexOf(min)], pending: pending };
  }
  function verdict(p) {
    var v = { fail: [], unknown: [], pending: false };
    each(parts(p), function (x) {
      var r = partRating(p, x.w);
      if (r.lbs !== null && r.lbs < MIN_LBS) v.fail.push({ pos: x.pos, sku: x.w.sku || '', lbs: r.lbs, src: r.src });
      else {
        if (r.pending) v.pending = true;
        else if (r.lbs === null) v.unknown.push({ pos: x.pos, sku: x.w.sku || '' });
      }
    });
    return v;
  }
  function note(p, v, where) {
    if (!p || p.id === undefined || has(hidden, String(p.id))) return;
    hidden[String(p.id)] = { id: p.id, set: [p.brand, p.display_model, p.finish, fmt(p.diameter_in) + '"', p.bolt_pattern_canonical].join(' '),
                             where: where, parts: v.fail };
  }
  // where = 'payload': the whole API list (the page then dedupes it itself, so a passing copy of a card wins on its own);
  // where = 'list': the page's deduped list for the grid - a failing set is swapped for a passing copy of its card if any
  function filterList(list, where) {
    var kept = [], drop = 0, ids = {};
    if (where === 'payload') order = list.slice();
    each(list, function (p) { if (p && p.id !== undefined) { seen[String(p.id)] = p; ids[String(p.id)] = 1; } });
    each(list, function (p) {
      var v = verdict(p);
      if (!v.fail.length) { kept.push(p); return; }
      note(p, v, where);
      var alt = where === 'list' ? findAlt(p, true) : null;
      if (alt && !ids[String(alt.id)]) { ids[String(alt.id)] = 1; kept.push(alt); } else drop++;
    });
    return { kept: kept, drop: drop };
  }

  // ---- count line: lower the "<strong>N</strong> Packages" number (same way the dead-link check does) -----------------
  function countDec(k) {
    var el = document.getElementById('rrw-dually-count');
    if (!el || !k) return;
    var ss = el.getElementsByTagName('strong');
    for (var i = 0; i < ss.length; i++) {
      var t = ss[i].nextSibling;
      if (!t || t.nodeType !== 3 || !/^\s*Packages?\b/.test(t.nodeValue)) continue;
      var n = parseInt(ss[i].textContent, 10);
      if (!isFinite(n)) return;
      var v = Math.max(0, n - k);
      ss[i].textContent = String(v);
      t.nodeValue = t.nodeValue.replace(/^(\s*)Packages?/, '$1' + (v === 1 ? 'Package' : 'Packages'));
      if (v === 0) {
        var f = (el.textContent || '').match(/(\d+)\s*forged option/);
        if (f) { var a = parseInt(f[1], 10); el.innerHTML = '<strong>' + a + '</strong> forged option' + (a === 1 ? '' : 's') + ' available'; }
      }
      return;
    }
  }
  function showEmpty() {   // same as the section's own "0 packages" branch
    var e = document.getElementById('rrw-dually-empty');
    if (!e) return;
    var bps = [];
    try { bps = new URLSearchParams(window.location.search).getAll('bp'); } catch (x) {}
    e.style.display = (bps.indexOf('10x285') !== -1 || bps.indexOf('10x285.75') !== -1) ? 'none' : '';
  }

  // ---- cards -------------------------------------------------------------------------------------------------------
  function gridEl() { return grid || (grid = document.getElementById('rrw-dually-grid')); }
  function pkgCards() {
    var g = gridEl(), out = [];
    if (!g) return out;
    each(g.children, function (c) {
      if (c.tagName === 'ARTICLE' && c.classList.contains('rrw-dpkg') && !c.classList.contains('rrw-dpkg--af') && c.__pkg) out.push(c);
    });
    return out;
  }
  // a copy of the same card (same key, other offsets) whose wheels all pass and are already checked, not on the page yet
  function findAlt(p, anyPage) {
    // 2026-11-03: a card's other height (the Stock Height | Lifted Truck switch on rrw-dually-shop) stands in first
    var la = p && p.__rrwLiftAlt;
    if (la) { var lv = verdict(la); if (!lv.fail.length && !lv.pending) { la.__rrwLiftAlt = null; return la; } }
    var k = ckey(p), on = {};
    if (!anyPage) each(pkgCards(), function (c) { on[String(c.__pkg.id)] = 1; });
    for (var i = 0; i < order.length; i++) {
      var a = order[i];
      if (!a || String(a.id) === String(p.id) || on[String(a.id)] || ckey(a) !== k) continue;
      var v = verdict(a);
      if (!v.fail.length && !v.pending) return a;
    }
    return null;
  }
  function replaceOrDrop(c) {
    var n = null;
    try { var alt = findAlt(c.__pkg); if (alt) n = window.rrwRenderDuallyPackage(alt); } catch (e) { n = null; }
    if (n && c.parentNode) { c.parentNode.replaceChild(n, c); return; }   // same card, a copy that passes: count unchanged
    if (c.parentNode) c.parentNode.removeChild(c);
    countDec(1);
  }
  function dropCard(c) {
    if (c.__rrwLgDropped) return;
    c.__rrwLgDropped = 1;
    if (c.classList.contains('rrw-dpkg--checking') && 'MutationObserver' in window) {
      // the dead-link check still runs on this card: hide it now, finish when that check is done (if the check
      // removes or replaces the card itself, it already fixed the count)
      c.style.display = 'none';
      var mo = new MutationObserver(function () {
        if (!c.parentNode) { mo.disconnect(); return; }
        if (!c.classList.contains('rrw-dpkg--checking')) { mo.disconnect(); replaceOrDrop(c); }
      });
      mo.observe(c, { attributes: true, attributeFilter: ['class'] });
      return;
    }
    replaceOrDrop(c);
  }
  function checkCard(c) {
    var v = verdict(c.__pkg);
    if (v.fail.length) { note(c.__pkg, v, 'card'); dropCard(c); return; }
    if (v.pending) c.classList.add('rrw-dpkg--lgpending');
    else c.classList.remove('rrw-dpkg--lgpending');
  }
  var changeQueued = false;
  function changed() {
    if (changeQueued) return;
    changeQueued = true;
    setTimeout(function () {
      changeQueued = false;
      try {
        each(pkgCards(), checkCard);
        if (cur) each(cur.list, function (p) {          // sets not drawn yet ("Show more"): take them off the count now
          var id = String(p.id);
          if (cur.shown[id] || cur.failed[id]) return;
          var v = verdict(p);
          if (v.fail.length) { cur.failed[id] = 1; note(p, v, 'list'); if (!findAlt(p)) countDec(1); }   // with a passing copy, that copy is drawn instead
        });
      } catch (e) {}
    }, 0);
  }

  // ---- hooks -------------------------------------------------------------------------------------------------------
  // 1) the package list itself: sets with a confirmed < 3,000 lb wheel never reach the page's count / chips / dedupe
  if (typeof _fetch === 'function') {
    window.fetch = function (input, init) {
      var res = _fetch.apply(window, arguments), hit = false;
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        var meth = String((init && init.method) || (input && typeof input === 'object' && input.method) || 'GET').toUpperCase();
        hit = meth === 'GET' && String(u).indexOf(PKG_API) === 0;
      } catch (e) { hit = false; }
      if (!hit) return res;
      return res.then(function (r) {
        if (!r || !r.ok) return r;
        return r.clone().json().then(function (j) {
          if (!j || !Array.isArray(j.packages)) return r;
          var f = filterList(j.packages, 'payload');
          if (!f.drop) return r;
          var out = {};
          for (var k in j) if (has(j, k)) out[k] = j[k];
          out.packages = f.kept;
          if (typeof j.total === 'number') out.total = f.kept.length;
          return new Response(JSON.stringify(out), { status: r.status, statusText: r.statusText, headers: { 'Content-Type': 'application/json' } });
        }).catch(function () { return r; });
      });
    };
  }

  // 2) the card renderers (from snippets/rrw-dually-package-card.liquid): filter again with what the live lookup knows
  function wrap() {
    var one = window.rrwRenderDuallyPackage, list = window.rrwRenderDuallyPackages;
    if (typeof one !== 'function' || typeof list !== 'function') return false;
    if (one.__rrwLg) return true;
    var w1 = function (p) {
      var v;
      try { v = verdict(p); } catch (e) { v = { fail: [] }; }
      if (v.fail.length) {                 // draw a passing copy of the same card instead, if there is one; else nothing
        note(p, v, 'card');                // (the dead-link check then tries its next copy of the set)
        var alt = null;
        try { alt = findAlt(p); } catch (e) { alt = null; }
        if (alt && cur && p && p.id !== undefined) cur.shown[String(p.id)] = 1;   // its slot is taken by the copy
        return alt ? w1.call(this, alt) : null;
      }
      var n = one.apply(this, arguments);
      try {
        if (n && p) {
          if (cur && p.id !== undefined) cur.shown[String(p.id)] = 1;
          need(p);
          if (verdict(p).pending) {
            var c = n.querySelector ? n.querySelector('.rrw-dpkg') : null;
            if (c) c.classList.add('rrw-dpkg--lgpending');
          }
        }
      } catch (e) {}
      return n;
    };
    w1.__rrwLg = 1;
    var wl = function (packages, container) {
      var g = gridEl();
      if (!g || container !== g || !Array.isArray(packages)) return list.apply(this, arguments);
      var f;
      try { f = filterList(packages, 'list'); } catch (e) { f = { kept: packages, drop: 0 }; }
      cur = { list: f.kept, shown: {}, failed: {} };
      if (f.drop) countDec(f.drop);
      var r = list.call(this, f.kept, container);
      try {
        if (!f.kept.length && packages.length) showEmpty();
        var ks = {};
        each(f.kept, function (p) { each(parts(p), function (x) { var k = gkey(p, x.w); if (k) ks[k] = 1; }); });
        var all = Object.keys(ks);
        if (all.length <= EAGER_GROUPS) each(all, load);
      } catch (e) {}
      return r;
    };
    wl.__rrwLg = 1;
    window.rrwRenderDuallyPackage = w1;
    window.rrwRenderDuallyPackages = wl;
    return true;
  }
  if (!wrap()) {
    var tries = 0, t = setInterval(function () { if (wrap() || ++tries > 200) clearInterval(t); }, 50);
  }

  // 3) safety net: any package card added to the grid by another path is checked too
  function watch() {
    var g = gridEl();
    if (!g || !('MutationObserver' in window)) return false;
    new MutationObserver(function (ms) {
      each(ms, function (m) {
        each(m.addedNodes, function (c) {
          if (c.nodeType === 1 && c.tagName === 'ARTICLE' && c.classList.contains('rrw-dpkg') && !c.classList.contains('rrw-dpkg--af') && c.__pkg) {
            try { checkCard(c); need(c.__pkg); } catch (e) {}
          }
        });
      });
    }).observe(g, { childList: true });
    return true;
  }
  if (!watch()) document.addEventListener('DOMContentLoaded', watch);

  try {
    var st = document.createElement('style');
    st.setAttribute('data-rrw', 'dually-loadguard-2026-10-13');
    st.textContent = '.rrw-dpkg--lgpending .rrw-dpkg__cta{opacity:.55;pointer-events:none;cursor:progress}';
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}

  window.RRWDuallyLoadGuard = {
    version: '2026-10-13',
    minLbs: MIN_LBS,
    built: DATA.built || '',
    verdict: verdict,
    // 2026-11-03: the card's Stock Height | Lifted Truck switch asks here first; cb(true) once every wheel of p is known
    // to pass (loads the ratings it needs; gives up after ~12 s)
    check: function (p, cb) {
      try { need(p); } catch (e) {}
      var n = 0;
      (function again() {
        var v;
        try { v = verdict(p); } catch (e) { v = { fail: [], pending: false }; }
        if (v.fail.length) return cb(false);
        if (!v.pending) return cb(true);
        if (++n > 60) return cb(false);
        setTimeout(again, 200);
      })();
    },
    report: function () {
      var unknown = {}, lookups = {};
      for (var id in seen) if (has(seen, id)) {
        var p = seen[id], v = verdict(p);
        if (v.fail.length) continue;
        each(v.unknown, function (u) {
          var k = u.sku || ('?' + id + ':' + u.pos);
          (unknown[k] = unknown[k] || { sku: u.sku, pos: u.pos, brand: p.brand, sets: [] }).sets.push(p.id);
        });
      }
      for (var k in groups) if (has(groups, k)) lookups[k] = { state: groups[k].state, rows: groups[k].rows, total: groups[k].total };
      var h = [];
      for (var hid in hidden) if (has(hidden, hid)) h.push(hidden[hid]);
      return { rule: 'every wheel >= ' + MIN_LBS + ' lb (DRW)', built: DATA.built || '', hidden: h, unknown: unknown, lookups: lookups };
    }
  };
})();
